import React from "react";
import { HelpItem } from "../../../../../Axios/services/help.service";
import HelpCard from "../HelpCard";
import LoadingSpinner from "../LoadingSpinner";
import styles from "./HelpItemsGrid.module.scss";

interface HelpItemsGridProps {
  helpItems: HelpItem[];
  loading: boolean;
  isAuthenticated: boolean;
  hasUserData: boolean;
}

const HelpItemsGrid: React.FC<HelpItemsGridProps> = ({
  helpItems,
  loading,
  isAuthenticated,
  hasUserData
}) => {
  // Show loading spinner while checking authentication or loading data
  if (loading) {
    return <LoadingSpinner message="Loading help items..." />;
  }

  // Show authentication required message only if no user data and not loading
  if (!hasUserData && !loading) {
    return (
      <div className={styles.authRequiredState}>
        <div className={styles.authIcon}>🔐</div>
        <h3>Authentication Required</h3>
        <p>Please log in to access help resources and support materials.</p>
      </div>
    );
  }

  if (helpItems.length === 0) {
    return (
      <div className={styles.emptyState}>
        <div className={styles.emptyIcon}>📚</div>
        <h3>No help items available</h3>
        <p>Help resources will appear here when they become available.</p>
      </div>
    );
  }

  return (
    <div className={styles.helpItemsSection}>
      <div className={styles.sectionHeader}>
        <p>Browse our collection of helpful resources and guides</p>
      </div>
      
      <div className={styles.helpItemsGrid}>
        {helpItems.map((item) => (
          <HelpCard key={item.Id} item={item} />
        ))}
      </div>
    </div>
  );
};

export default HelpItemsGrid;